module.exports = require("./dist/ocLazyLoad.min.js");


//////////////////
// WEBPACK FOOTER
// oclazyload (bower component)
// module id = 1389
// module chunks = 0